import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ShieldCheck, CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [state, setState] = useState("verifying"); // verifying | ok | fail

  useEffect(() => {
    let active = true;
    (async () => {
      if (!token) { setState("fail"); return; }
      try {
        await api.post("/auth/verify-email", { token });
        if (active) setState("ok");
      } catch {
        if (active) setState("fail");
      }
    })();
    return () => { active = false; };
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center p-8 ek-scanline">
      <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm border p-8 text-center" style={{ background: "var(--ek-surface)", borderColor: "var(--ek-border)" }} data-testid="verify-email-card">
        <div className="flex items-center justify-center gap-2 mb-6">
          <ShieldCheck className="h-5 w-5" style={{ color: "var(--ek-primary)" }} />
          <span className="font-head font-bold tracking-tight">EvidenceKeeper</span>
        </div>
        {state === "verifying" && <p className="ek-mono-label ek-pulse">VERIFYING EMAIL...</p>}
        {state === "ok" && (
          <>
            <CheckCircle2 className="h-10 w-10 mx-auto mb-4" style={{ color: "var(--ek-secure)" }} />
            <p className="mb-6" style={{ color: "var(--ek-text-secondary)" }}>Your email is verified. Your account is fully activated.</p>
            <Button data-testid="verify-continue-btn" onClick={() => navigate("/")} className="w-full rounded-md" style={{ background: "var(--ek-primary)", color: "#fff" }}>Continue</Button>
          </>
        )}
        {state === "fail" && (
          <>
            <XCircle className="h-10 w-10 mx-auto mb-4" style={{ color: "var(--ek-error)" }} />
            <p className="mb-6" style={{ color: "var(--ek-text-secondary)" }}>This verification link is invalid or has expired. Sign in and request a new one.</p>
            <Button data-testid="verify-back-btn" onClick={() => navigate("/")} className="w-full rounded-md" style={{ background: "var(--ek-primary)", color: "#fff" }}>Back to sign in</Button>
          </>
        )}
      </motion.div>
    </div>
  );
}
